<template>
  <Dialog v-model:visible="showDialog" :modal="true" :header="model ? $t('HSN.Edittitle') : $t('HSN.title')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }" @after-hide="IsClear">
    <div>
      <b-form @submit.prevent="IsSubmit">
        <b-row>
          <b-col sm="6">
            <div class="field">
              <TextField name="code" id="code" :label="$t('HSN.code')" :rules="{ required: true }" :disabled="true"
                v-model="hsnform.Code" placeholder=" " />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <div class="field">
              <label>{{ $t("HSN.hsncode") }}<span class="red"> *</span></label>
              <AutoCompleteCustom name="Hsn code" id="Hsn code" :label="$t('HSN.hsncode')" :requiredIcon="true" :rules="{
                required: true,
                twelveDigitValid: true,
                numeric: true,
              }" :items="LoadHSNCodeName.HSNCodeOption" @input="loadHSNCode(hsnform.HSNCode)" v-model="hsnform.HSNCode"
                placeholder=" " :autofocus="true" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="8">
            <div class="field">
              <TextField name="Name" id="Name" :label="$t('HSN.name')" :rules="{ required: true, alphabet: false }"
                :requiredIcon="true" v-model="hsnform.Name" placeholder=" " case="Capital" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <div class="field">
              <CustomDropdown :label="$t('HSN.purchasetax')" :name="$t('HSN.purchasetax')" :id="$t('HSN.purchasetax')"
                v-model="hsnform.PurchaseTaxId" :items="selectOption.ptaxOptions" @update:value="" @input="" />
            </div>
          </b-col>
          <b-col sm="6">
            <div class="field">
              <CustomDropdown :label="$t('HSN.salestax')" :name="$t('HSN.salestax')" :id="$t('HSN.salestax')"
                v-model="hsnform.SalesTaxId" :items="selectOption.staxOptions" @update:value="" @input="" />
            </div>
          </b-col>
        </b-row>
        <Footer @cancel="(showDialog = false), IsClear()" :cancelhide="false" :label="label" :loading="Saveloading" />
      </b-form>
    </div>
  </Dialog>
  <StoreTax v-if="DialogShow.StockHSNCode" @close="DialogShow.StockHSNCode = false" @loaderhide="loading = false"
    @loadershow="loading = true" :OperationID="ObjOperationId" :EntityId="EntityIds.Tax"
    :visibleRight="DialogShow.StockHSNCode" :TaxType="TaxValue" :PopupType="PopupValue" />

  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />

  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import HsnService from "../../../../../../modules/Inventory/Service/HsnService";
// import HsnLinkservices from "../../../../modules/Inventory/Service/HsnlinkService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/CommonService";
import TaxService from "../../../../../../modules/Inventory/Service/TaxService";
// import MultipleSelectDropdown from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";

import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";
import StoreTax from "../../../../components/MasterCreation/StoreTax.vue";
import MastersService from "../../../../Service/MastersService";
import { checkPermission } from "../../../../Service/AccessControl";
import { useToast } from "primevue/usetoast";
import { numeric } from "@vee-validate/rules";
import AutoCompleteCustom from "../../../../../../components/FormComponents/AutoComplete.vue";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    TextField,

    Footer,
    CustomDropdown,
    AlreadyExist,
    Loader,
    StoreTax,
    AutoCompleteCustom,
  },
  setup(props, { emit }) {
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const alreadyexistpop = ref(false);
    let loading = ref(false);
    let Saveloading = ref(false);
    const label = ref(t("btn.save"));
    let session: any = localStorage.getItem("UsersData");
    const toast = useToast();
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let IsAdmin = Number(session.Admin);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let Entitydata = ref({
      EntityId: 0,
    });

    let EntityIds = ref({
      Tax: 3017,
    });

    let taxtypeOption = [
      {
        value: 1,
        name: "Purchase Tax",
      },
      {
        value: 2,
        name: "Sales Tax",
      }
    ];

    const LoadHSNCodeName: any = ref({
      HSNCodeOption: [],
    });

    Entitydata.value.EntityId = props.EntityId;
    let TaxValue = ref(1);
    let PopupValue = ref(1);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);


    const hsnform = ref({
      CreatedAt: "",
      ModifiedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      Id: 0,
      HSNCode: "",
      Code: "",
      Name: "",

      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
      TxnType: 1,
      TaxId: 0,
      PurchaseTaxId: 0,
      SalesTaxId: 0,
      OrganizationId: 0,
      Type: 1,
      ValidFrom: "",
      ValidTo: "",
    });

    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);

      if (model.value != null) {
        IsEdit();
      } else {
        IsCreate();
        LoadTax();
      }
    });


    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false &&
          alreadyexistpop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    const selectOption = ref({
      ptax: ref(),
      ptaxOptions: [],
      stax: ref(),
      staxOptions: [],
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      StockHSNCode: false,
    });

    async function GetCode() {
      debugger;
      let data = {
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
        Iscommon: 1,
        RoleId: rolesData.RoleId || 0,
      };
      let result: any = await common.getCodeTemplate(data);

      hsnform.value.Code = result;
    }

    const IsSubmit = async () => {
      emit("loadershow");
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }
        Saveloading.value = false;
        return;
      }
      debugger;
      try {
        hsnform.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        hsnform.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        hsnform.value.BranchId = BranchId;
        hsnform.value.HospitalId = HospitalId;
        hsnform.value.ModifiedBy = UserId;
        hsnform.value.CreatedBy = UserId;
        hsnform.value.EntityId = Number(Entitydata.value.EntityId);
        hsnform.value.Code = hsnform.value.Code?.toString() ?? "";
        hsnform.value.OrganizationId = HospitalId;
        hsnform.value.HSNCode = hsnform.value.HSNCode?.toString() ?? "";
        hsnform.value.ValidFrom = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        hsnform.value.ValidTo = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");

        if (hsnform.value.Id != 0) {
          hsnform.value.EntityOperationId = props.OperationID.UpdateId;
          const response = await HsnService.updatedata(hsnform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            emit("loaderhide");
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {

            emit("loaderhide");
            Saveloading.value = false;
            updatepop.value = true;
          }
        } else {
          hsnform.value.EntityOperationId = props.OperationID.CreateId;
          const response = await HsnService.createdata(hsnform.value);
          console.log(hsnform.value);
          let message = response["ErrorInfo"].ErrorCode;
          if (response["result"] == "Already" && message == null) {
            emit("loaderhide");
            Saveloading.value = false;
            alreadyexistpop.value = true;
          }
          else if (message == null) {
            emit("loaderhide");
            Saveloading.value = false;
            successpop.value = true;
          }
        }
      } catch (error) {
        emit("loaderhide");
        Saveloading.value = false;
        alert(error);
      }
    };


    async function LoadTax() {
      try {
        // Load Purchase Tax (TxnType = 1)
        const purchaseResponse = await TaxService.GetTaxlistByTaxType(
          HospitalId,
          1
        );
        selectOption.value.ptaxOptions = purchaseResponse["result"]
          .map((item) => {
            item.name = item.TaxName;
            item.value = item.Id;
            return item;
          });

        // Load Sales Tax (TxnType = 2)
        const salesResponse = await TaxService.GetTaxlistByTaxType(
          HospitalId,
          2
        );
        selectOption.value.staxOptions = salesResponse["result"]
          .map((item) => {
            item.name = item.TaxName;
            item.value = item.Id;
            return item;
          });

      } catch (error) {
        alert(error);
      }
    }

    //Edit Function
    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");

      try {
        label.value = "Update";
        let Id = model.value.Id;
        const response = await HsnService.getfindonedata(Id, HospitalId);
        debugger;
        let data = response["result"];
        // hsnform.value.Id = Id;
        // hsnform.value.Name = data["Name"];
        // hsnform.value.HSNCode = data["HSNCode"];
        // hsnform.value.Code = data["Code"];

        Object.keys(hsnform.value).forEach((key) => {
          if (data[key]) hsnform.value[key] = data[key];
        });

        LoadTax()

        emit("loaderhide");

        Editmodel.value = false;
      } catch (error) {
        emit("loaderhide");

        alert(error);
      }
    }

    //Clear Function
    function IsClear() {
      hsnform.value.Id = 0;
      hsnform.value.Name = "";
      hsnform.value.HSNCode = "";
      hsnform.value.BranchId = 0;

      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");

      selectOption.value.stax = "";
      selectOption.value.ptax = "";
    }

    function IsEditpop() {
      Editmodel.value = true;
    }

    function closetrigger() {
      IsClear();
      emit("load");
      successpop.value = false;
      updatepop.value = false;
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      hsnform.value.Name = "";
    }

    async function FunctionRights(EntityId, FieldType, Type) {
      debugger;
      TaxValue.value = Type;
      PopupValue.value = TaxValue.value == 1 ? 1 : 2;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function onTaxTypeChanged(val) {
      debugger;
      hsnform.value.TxnType = val;
      hsnform.value.TaxId = 0;
      LoadTax();
    }

    const loadHSNCode = async (Code) => {
      debugger;

      const query = Code?.trim() || "";
      if (query != "") {
        try {
          const response = await HsnService.getHsnNameAutocomplete(
            query,
            1,
            HospitalId
          );

          LoadHSNCodeName.value.HSNCodeOption = response["result"].map(
            (item: any) => {
              item.label = item.Code;
              item.value = item.id;
              return item;
            }
          );
        } catch (error) { }
      }
    };

    return {
      Saveloading,
      loading,
      IsEditpop,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      showDialog,
      IsCreate,
      IsClear,
      IsEdit,
      LoadTax,
      hsnform,
      IsSubmit,
      selectOption,
      alreadyclosetrigger,
      alreadyexistpop,
      label,
      ObjOperationId,
      FunctionRights,
      EntityIds,
      DialogShow,
      TaxValue,
      model,
      PopupValue,
      taxtypeOption,
      onTaxTypeChanged,
      LoadHSNCodeName,
      loadHSNCode,
    };
  },

});
</script>
